import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';
import React from 'react';

interface MobileAlertDialogProps {
  open: boolean;
  onClose: () => void;
}

const MobileAlertDialog: React.FC<MobileAlertDialogProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
    <DialogTitle id="alert-dialog-title">Prior Communication</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Zicasso has moved to a new messaging platform. Previous email communications are not included in this chat.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary" variant="outlined" sx={{ width: '100%' }}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default MobileAlertDialog;
